import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PACKAGELOCATIONSELECTION } from "@const";
import { PACKAGELOCATION } from "@type";
import * as _ from "lodash";
import { UserService } from "../services/user.service";

@Component({
  selector: "app-mode-of-service",
  templateUrl: "./mode-of-service.component.html",
  styleUrls: ["./mode-of-service.component.scss"],
})
export class ModeOfServiceComponent implements OnInit {
  @Input() visitOptions: any = {};
  @Input() type;
  @Output() action = new EventEmitter();
  @Output() next = new EventEmitter();
  @Output() close = new EventEmitter();
  public hideClinicOptFromModeOfService: boolean;
  public hideHomeVideoOptFromModeOfService: boolean; 
  public selectedAppointmentType: PACKAGELOCATION;
  public appointmentLocationOptions = [];
  constructor(private user: UserService,) {
      this.user.getConfigurationInfo.subscribe(data => {
        this.hideClinicOptFromModeOfService = data['pxAppSettings']['hideClinicOptFromModeOfService'] == 'Y' ? true : false;
        this.hideHomeVideoOptFromModeOfService = data['pxAppSettings']['hideHomeVideoOptFromModeOfService'] == 'Y' ? true : false;
      })
  }

  ngOnInit() {

    if (this.visitOptions?.modeOfVisits?.length) {
      this.appointmentLocationOptions = _.cloneDeep(PACKAGELOCATIONSELECTION).filter((s) => this.visitOptions.modeOfVisits.includes(s.value));
      const disableMap: Record<string, boolean> = {
        CLINIC: this.hideClinicOptFromModeOfService,
        HOMECARE: this.hideHomeVideoOptFromModeOfService
      };

      this.appointmentLocationOptions = this.appointmentLocationOptions.map(option => ({
        ...option,
        disable: disableMap[option.value] ?? option.disable
      }));
      const visible = this.appointmentLocationOptions.filter(o => !o.disable);

      if (visible.length >= 1 && !this.selectedAppointmentType) {
        this.selectedAppointmentType = visible[0].value;
      }
    }
  }

  public closeModal(ev) {
    this.action.emit(ev);
  }
  public bookAppointment() {
    this.next.emit({data: this.selectedAppointmentType,state: "MODE_OF_SERVICE",key: "modeOfService",})
  }

  public packdtl(value, u?) {
    console.info("packdtl", value, u);
  }

  public handleRadioChange(ev) {
    this.selectedAppointmentType = ev.target.value;
  }

  selectMode(mode) {
    this.selectedAppointmentType = mode;
  }
}
